import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Column, Row, Typography } from 'seagull';
import styles from './PermissionRow.module.scss';
export const PermissionRow = (param)=>{
    let { icon, title, description, intent, testId } = param;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 3,
        alignItems: "start",
        className: styles.row,
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.iconBadge,
                "data-intent": intent,
                "aria-hidden": "true",
                children: icon
            }),
            /*#__PURE__*/ _jsxs(Column, {
                gap: 1,
                className: styles.text,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "bold",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "secondary",
                        children: description
                    })
                ]
            })
        ]
    });
};
